export default __webpack_public_path__ + "static/char-s-33-zh-Hans-dfacefeebf2d5753339333fc18228d26.webp";